import {createSlice} from "@reduxjs/toolkit";

export const callTypes = {
  list: "list",
  action: "action"
};

export const slice = createSlice({
  name: "meatsCategories",
  initialState: {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    meatsCategories: [],
    meatsCategoriesInit: [],
    meatsCategoryForEdit: undefined,
    lastError: null,
    lang:"en",
    test:"aaa"
  },
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    meatsCategoriesFetched: (state, action) => {
      const { totalCount, entities, lang } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.meatsCategories = entities;
      state.totalCount = totalCount;
    },
    // changelang
    changeLang: (state, action) => {
      // state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.lang = action.payload.lang;
    },
    // getProductById
    meatsCategoryFetched: (state, action) => {
      // console.log("action.payload",action.payload)
      state.actionsLoading = false;
      state.meatsCategoryForEdit = action.payload._data;
      state.error = null;


    },
    // findProducts
    meatsCategoriesInit: (state, action) => {
      const { totalCount, _data } = action.payload;
      // console.log("OKOK",totalCount, _data)
      state.listLoading = false;
      state.error = null;
      state.meatsCategoriesInit = _data;
      state.meatsCategories = _data;
      state.totalCount = totalCount;
    },

    // createProduct
    meatsCategoryCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.meatsCategories.push(action.payload._data);
    },
    // updateProduct
    meatsCategoryUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;

      state.meatsCategories = state.meatsCategories.map(entity => {
        if (entity.id === action.payload._data.id) {
          return action.payload._data;
        }
        return entity;
      });
    },
    // deleteProduct
    meatsCategoryDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.meatsCategories = state.meatsCategories.filter(el => el.id !== action.payload.id);
    },
    // deleteProducts
    meatsCategoriesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.meatsCategories = state.meatsCategories.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    meatsCategoriesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.meatsCategories = state.meatsCategories.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
